export default {
    _banner       : null,
    _defaultSpeed : 4,
    init() {
        this._banner = document.querySelector('[data-parallax]');
        if (!this._banner) {
            return;
        }

        window.addEventListener('scroll', e => {
            const speed = this._banner.getAttribute('data-parallax');
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this._banner.children[0].style = `transform: translate3d(0px, ${scrollTop / (speed ? speed : 3)}px, 0px);`;
        });
    }
}